export default function ProductBanner() {
  return (
    <section className="relative w-full h-[200px] md:h-[260px] overflow-hidden">
      <img
        src="/images/banner02.jpg"
        alt="產品介紹"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-[#1a2535]/75" />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
        <p className="text-xs tracking-[0.35em] text-[#4fc3f7] uppercase mb-2">PRODUCTS</p>
        <h1 className="text-3xl md:text-4xl font-bold text-white tracking-widest">產品介紹</h1>
        <div className="flex items-center gap-2 mt-3">
          <a href="/index" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">首頁</a>
          <span className="text-gray-500 text-sm">/</span>
          <span className="text-white text-sm">產品介紹</span>
        </div>
      </div>
    </section>
  );
}
